// eslint-disable-next-line no-unused-vars
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { userLoginDataLayer, userLogoutDataLayer } from './lib/analytics/events'
import { initialiseGtm } from './lib/analytics/datalayer'

/**
 * - get `session` state from redux and send data layer user event
 *   - `userLoginDataLayer` or `userLogoutDataLayer` can be recalled when log-in / log-out / update on name, mobile, email
 * - send `gtm.js` (this is only sent once per app load)
 */
const GtmInitialiser = () => {
  const [isGtmInitialised, setGtmInitialised] = useState(false)
  const accountId = useSelector(
    state => state.session.decodedJwt?.accountId || ''
  )
  const email = useSelector(state => state.session.decodedJwt?.email || '')
  const mobile = useSelector(state => state.session.decodedJwt?.mobile || '')
  const firstName = useSelector(
    state => state.session.decodedJwt?.first_name || ''
  )
  const surname = useSelector(state => state.session.decodedJwt?.surname || '')
  const logInTimestamp = useSelector(state => state.session.logInTimestamp || 0)
  const logOutTimestamp = useSelector(
    state => state.session.logOutTimestamp || 0
  )

  useEffect(() => {
    const THRESHOLD_MILLISECONDS = 1000
    const hasJustLoggedOut =
      logOutTimestamp > 0 &&
      Date.now() - logOutTimestamp < THRESHOLD_MILLISECONDS
    const hasJustLoggedIn =
      logInTimestamp > 0 && Date.now() - logInTimestamp < THRESHOLD_MILLISECONDS
    if (accountId) {
      userLoginDataLayer(
        accountId,
        {
          email,
          mobile,
          firstName,
          surname
        },
        hasJustLoggedIn
      )
    } else {
      userLogoutDataLayer(hasJustLoggedOut)
    }
    if (!isGtmInitialised) {
      initialiseGtm()
      setGtmInitialised(true)
    }
  }, [
    accountId,
    email,
    mobile,
    firstName,
    surname,
    logInTimestamp,
    logOutTimestamp
  ])

  return null
}

export default GtmInitialiser
